/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { ValidationFaultPaymentDataErrorProblemJson } from "./ValidationFaultPaymentDataErrorProblemJson";
import { ValidationFaultPaymentUnknownProblemJson } from "./ValidationFaultPaymentUnknownProblemJson";

export const NodeProblemJson404 = t.union(
  [
    ValidationFaultPaymentDataErrorProblemJson,

    ValidationFaultPaymentUnknownProblemJson
  ],
  "NodeProblemJson404"
);

export type NodeProblemJson404 = t.TypeOf<typeof NodeProblemJson404>;
